var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('headers'),_c('div',{staticClass:"layout-main-content",staticStyle:{"min-height":"calc(100vh - 80px)"}},[_c('router-view')],1),_c('service-box'),_c('bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }